import { NgComponentOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';

import { useToaster } from '../../../composables/use-toaster';
import { ToasterComponent } from '../toaster/toaster.component';

/**
 * Single root host that renders every active toast from the {@link useToaster} store as a stacked
 * `app-toaster`. Mount this once near the app root; trigger toasts anywhere via `useToaster`.
 */
@Component({
    selector: 'app-toaster-host',
    templateUrl: './toaster-host.component.html',
    styleUrl: './toaster-host.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ToasterComponent, NgComponentOutlet],
})
export class ToasterHostComponent {
    private readonly toaster = useToaster();

    protected readonly toasts = this.toaster.toasts;
    protected readonly dismiss = this.toaster.dismiss;
}
